<template>
    <div class="col-12">
        <h4 class="header-title m-t-0">
            <i class="fas fa-hand-holding-usd mr-1"/>
            <span v-html="$t('CarrierTaxList.carrierTaxes')"/>
        </h4>
        <hr/>
        <v-client-table :data="carrier.taxes" :columns="table.columns" :options="table.options">
            <button @click="showCarrierTaxModal()" class="btn btn-primary pull-right" slot="afterLimit">
                <i class="fa fa-plus-circle mr-1"/>
                <span v-html="$t('CarrierTaxList.addCarrierTax')"/>
            </button>
            <span slot="percent" slot-scope="props" v-html="`${props.row.percent} %`"/>
            <span slot="country.name" slot-scope="props">
                <img class="shadow mr-1" width="30" alt="flag" :src="getDiceBaseUrl + props.row.country.flagURL"/>
                <span v-html="props.row.country.name"/>
            </span>
            <div class="text-center" slot="actions" slot-scope="props">
                <button v-tooltip="$t('CarrierTaxList.edit')" @click="showCarrierTaxModal(props.row)" class="btn btn-warning btn-xs mr-1">
                    <i class="fa fa-edit"/>
                </button>
                <CarrierTaxDeleteButton v-tooltip="$t('CarrierTaxList.delete')" :carrier-tax="props.row" @deleteCarrierTax="deleteCarrierTax"/>
            </div>
        </v-client-table>
        <CarrierTaxFormModal @addCarrierTax="addCarrierTax" @editCarrierTax="editCarrierTax" :carrier="carrier" ref="CarrierTaxFormModal"/>
    </div>
</template>

<script>
import CarrierTaxFormModal from "./CarrierTaxFormModal";
import CarrierTaxDeleteButton from "./CarrierTaxDeleteButton";
import {permissiveFilter} from "../../../../../helpers/VueTable";

export default {
    name: "CarrierTaxList",
    components: {CarrierTaxDeleteButton, CarrierTaxFormModal},
    props: {
        carrier: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            table: {
                columns: ["name", "percent", "country.name", "actions"],
                options: {
                    perPage: 10,
                    sortable: ["name", "percent", "country.name"],
                    headings: {
                        name: this.$t("CarrierTaxList.name"),
                        percent: this.$t("CarrierTaxList.percent"),
                        "country.name": this.$t("CarrierTaxList.country"),
                    },
                    orderBy: {
                        column: "name",
                    },
                    filterAlgorithm: {
                        name: (row, query) => permissiveFilter(row.name, query),
                        "country.name": (row, query) => permissiveFilter(row.country.name, query),
                    },
                },
            },
        };
    },
    methods: {
        showCarrierTaxModal(carrierTax = null) {
            this.$refs.CarrierTaxFormModal.show(carrierTax);
        },
        addCarrierTax(carrierTax) {
            this.$emit("addCarrierTax", carrierTax);
        },
        editCarrierTax(newCarrierTax) {
            this.$emit("editCarrierTax", newCarrierTax);
        },
        deleteCarrierTax(carrierTax) {
            this.$emit("deleteCarrierTax", carrierTax);
        },
        getDiceBaseUrl() {
            return this.$diceAPI.getBaseUrl();
        },
    },
};
</script>

<style scoped>

</style>